/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/react';
import { ToolTipContent } from '@atlaskit/editor-common/keymaps';
import { expandIconWrapperStyle } from '@atlaskit/editor-common/styles';
import { ToolbarButton } from '@atlaskit/editor-common/ui-menu';
import ExpandIcon from '@atlaskit/icon/glyph/chevron-down';
import AddIcon from '@atlaskit/icon/glyph/editor/add';
import { triggerWrapper } from './styles';
var DropDownButtonIcon = /*#__PURE__*/React.memo(function (props) {
  return (
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    jsx("span", {
      css: triggerWrapper
    }, jsx(AddIcon, {
      label: props.label
    }), jsx("span", {
      css: expandIconWrapperStyle
    }, jsx(ExpandIcon, {
      label: ""
    })))
  );
});
export var DropDownButton = /*#__PURE__*/React.memo(function (props) {
  return jsx(ToolbarButton, {
    ref: props.handleRef,
    selected: props.selected,
    disabled: props.disabled,
    onClick: props.onClick,
    onKeyDown: props.onKeyDown,
    spacing: props.spacing,
    "aria-expanded": props['aria-expanded'],
    "aria-haspopup": props['aria-haspopup'],
    "aria-keyshortcuts": props['aria-keyshortcuts'],
    "aria-label": "".concat(props.label),
    iconBefore: jsx(DropDownButtonIcon, {
      label: ""
    }),
    title: jsx(ToolTipContent, {
      description: props.label,
      shortcutOverride: "/"
    })
  });
});